import React from "react";
import styled from "styled-components";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "../../../Assets/styles/customPhoneSelect.css";
import {
  Hero, Globe, Title, Subtitle, Fields, PrimaryBtn, BackBtn, TermsFooter
} from "../shared/AuthUI";
import { useTranslate } from "@tolgee/react";

const PhoneStep = ({
  phone,
  setPhone,
  setCountryCode,
  onSigninSubmit,
  defaultCountry,
  onBack,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <BackBtn onClick={onBack}>{t("general.back")}</BackBtn>

      <Hero>
        <Globe>📱</Globe>
        <Title>{t("authentication.phone.title")}</Title>
        <Subtitle>{t("authentication.phone.subtitle")}</Subtitle>
      </Hero>

      <Fields>
        <PhoneInputWrapper>
          <PhoneInput
            international
            defaultCountry={defaultCountry}
            name="phoneNumber"
            placeholder={t("authentication.type_phone_number")}
            value={phone}
            onChange={(val) => setPhone(val)}
            onCountryChange={(code) => setCountryCode(code)}
            limitMaxLength
            onKeyDown={(e) => {
              if (e.key === "Enter" && phone && phone.length >= 8) {
                onSigninSubmit(e);
              }
            }}
          />
        </PhoneInputWrapper>

        <PrimaryBtn
          disabled={!phone || phone.length < 8}
          onClick={onSigninSubmit}
        >
          {t("authentication.phone.send_code_button")}
        </PrimaryBtn>
      </Fields>

      <TermsFooter />
    </>
  );
};

export default PhoneStep;

const PhoneInputWrapper = styled.div`
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  padding: 0 14px;
  display: flex;
  align-items: center;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.menu.selectedTextColor};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.menu.selectedTextColor}22;
  }

  .PhoneInput {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .PhoneInputCountry {
  margin: 0;
  align-self: center;
    background: ${({ theme }) => theme.chat.selectedBackground};
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    cursor: pointer;
    position: relative;
    padding: 0;
    overflow: hidden;
    line-height: 0;
  }

  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
  }

  .PhoneInputCountryIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    line-height: 0;
  }

  .PhoneInputCountryIcon svg,
  .PhoneInputCountryIcon img {
    display: block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }

  .PhoneInputCountryIconUnicode {
    font-size: 20px;
    line-height: 1;
  }

  .PhoneInputCountrySelectArrow { display: none; }
  .PhoneInputCountryIcon--border { box-shadow: none; }
  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border { box-shadow: none; }

  input.PhoneInputInput {
    flex: 1;
    background: none;
    border: none;
    outline: none;
    font-size: 15px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    padding: 14px 0;
    font-family: inherit;

    &::placeholder {
      color: ${({ theme }) => theme.menu.secondaryTextColor};
      opacity: 0.7;
    }
  }
`;
